import StopWeightCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import numberWithCommas from 'utils/numberWithCommas';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const t = {
  kg: 'kg',
};

const fields = ['total_weight'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { total_weight: totalWeight } = props.selectors.getJourneyStopFields(
      state,
      props.journeyId,
      props.stopId,
      fields
    );

    return {
      totalWeight: numberWithCommas(totalWeight),
      weightUnit: t.kg,
    };
  })
);

export default enhance(StopWeightCell);
